export default __webpack_public_path__ + "static/media/chirp.f60badc5.png";